import React from 'react';
import { Outlet } from 'components/Routing';
import AppContext from 'components/appContext';
import procEvalConfig from './moduleConfig'
import {appendScript} from 'sis_ui/utils/appendScript'
import config from 'root/../config';

const moduleCode = "PROCEDURE_EVALUATIONS_MODULE";

export default class Evaluations extends React.Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
    }

    componentDidMount(){
        this.context.registerModule(moduleCode, procEvalConfig.map);
        this.context.setCurrentModule(moduleCode);
        appendScript(config.uiAppUrl + "/dist/UIHelper.js");
    }

    render() {
        return (
           <Outlet />
        )
    }
}